(function () {
  var path = window.location.pathname;
  // Only redirect from the default (Dutch) pages, never from /fr/ or /en/
  if (/^\/(fr|en)(\/|$)/.test(path)) return;
  // Skip on local development (no localized folders on the dev server)
  if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") return;

  var stored = null;
  try {
    stored = localStorage.getItem("preferred-language");
  } catch (e) {}
  var lang = stored || (navigator.language || "en").slice(0, 2).toLowerCase();
  if (lang === "nl") return;
  var target = lang === "fr" ? "fr" : "en";
  window.location.replace("/" + target + path + window.location.search + window.location.hash);
})();
